import * as React from 'react'

import Button from '@doordash/component-button'
import { IdentificationField } from '@doordash/component-fields'
import { Text, Stack, StackChildren } from '@doordash/design-language'
import Form from '../../../../utilities/Form'
// tslint:disable-next-line:max-line-length
import { validators as sharedValidators } from '../../../../utilities/validators'
import { BirthdateInputSplit } from '../../../atoms/birthdate-input'

import * as DA from '../../../../typeModules/events'
import t from '../strings'

import { BackgroundCheck as Tag } from '../../../../models/selectorAnchors'

type Props = {
  uniqueLink?: string
  error?: string
  onSubmit?: any
  trackBackgroundCheckSteps: (data: DA.TrackBackgroundCheck) => Promise<any>
}

class IdentificationStep extends React.Component<Props> {
  public static fields = {
    ssn: '',
    birthday: '',
  }

  public static validators: any = {
    ssn: sharedValidators.ssn,
    birthday: sharedValidators.birthday,
  }
  public componentDidMount() {
    this.props.trackBackgroundCheckSteps({
      page: DA.BackgroundCheckPages.BackgroundCheck,
      action: DA.EventActions.Rendered,
    })
  }
  public render() {
    return (
      <React.Fragment>
        <Stack size={Stack.Sizes.XxSmall}>
          <Text styles={Text.Styles.PageTitle}>{t.title()}</Text>
        </Stack>
        <StackChildren>
          <Text styles={Text.Styles.PageDescriptionBody}>
            {t.backgroundCheckDescription()}
          </Text>

          <Form
            onSubmit={this.props.onSubmit}
            validators={IdentificationStep.validators}
            fields={IdentificationStep.fields}
          >
            {(fields, handleChange, handleSubmit, { isLoading }) => (
              <form onSubmit={handleSubmit}>
                <StackChildren size={StackChildren.Sizes.Large}>
                  <BirthdateInputSplit
                    id="birthdate-input-split"
                    label={t.birthdate()}
                    onChange={handleChange.bind(this, 'birthday')}
                    birthdayField={fields.birthday}
                    data-anchor-id={Tag.BirthdateContainer}
                    monthAnchorId={Tag.BirthdateMonth}
                    dayAnchorId={Tag.BirthdateDay}
                    yearAnchorId={Tag.BirthdateYear}
                    {...fields.birthday}
                  />
                  <IdentificationField
                    country="US"
                    accessibilityDescribedBy={'socialSecurityNumber'}
                    onChange={handleChange.bind(this, 'ssn')}
                    label={t.socialSecurityNumber()}
                    description={t.required()}
                    autoComplete="off"
                    data-anchor-id={Tag.PersonalIdentificationNumber}
                    {...fields.ssn}
                  />
                  <Button
                    accessibilityDescribedBy={'submitBackgroundCheck'}
                    onClick={async () => {
                      this.props.trackBackgroundCheckSteps({
                        page: DA.BackgroundCheckPages.BackgroundCheck,
                        action: DA.EventActions.Continue,
                      })
                      try {
                        await handleSubmit()
                      } catch (e) {
                        this.props.trackBackgroundCheckSteps({
                          page: DA.BackgroundCheckPages.BackgroundCheck,
                          action: DA.EventActions.Error,
                          value: e,
                        })
                      }
                    }}
                    state={
                      isLoading ? Button.States.Loading : Button.States.Default
                    }
                    data-anchor-id={Tag.PrimaryAction}
                  >
                    {t.continue()}
                  </Button>
                </StackChildren>
              </form>
            )}
          </Form>
        </StackChildren>
      </React.Fragment>
    )
  }
}

export default IdentificationStep
